export default "__VITE_PUBLIC_ASSET__fdbd1eee__"